import React from "react"
import styled from "styled-components"
import media from "styles/media"
import colors from "styles/colors"
import text from "styles/text"

const AssetHero = ({ content }) => {
  return (
    <Wrapper $bgColor={content?.backgroundColor}>
      <TextContentDiv $textcolor={content?.textColor}>
        {content?.eyebrow && <Eyebrow>{content?.eyebrow}</Eyebrow>}
        {content?.header && <Header>{content?.header}</Header>}
        {content?.subheader && <SubHeader>{content?.subheader}</SubHeader>}
      </TextContentDiv>
      <HeroImage
        alt={content?.image?.altText}
        src={content?.heroImage?.sourceUrl}
      />
    </Wrapper>
  )
}

export default AssetHero

const HeroImage = styled.img`
  position: relative;
  align-self: flex-end;
  width: 33.958vw;
  height: 33.958vw;

  ${media.fullWidth} {
    width: 489px;
    height: 489px;
  }

  ${media.tablet} {
    width: 37.598vw;
    height: 37.598vw;
  }

  ${media.mobile} {
    width: 89.953vw;
    height: 89.953vw;
  }
`
const SubHeader = styled.p`
  ${text.bodyLg}
`
const Header = styled.h2`
  ${text.h2}
  ${media.fullWidth} {
  }

  ${media.tablet} {
    ${text.h2}
  }

  ${media.mobile} {
    ${text.h2}
  }
`
const Eyebrow = styled.p`
  ${text.eyebrow}
`
const TextContentDiv = styled.div`
  display: flex;
  flex-direction: column;
  margin: 9.653vw 0vw 6.944vw 0vw;
  color: ${props =>
    props.$textcolor ? `${colors[props.$textcolor]}` : "white"};
  gap: 2.778vw;
  width: 39.167vw;

  ${media.fullWidth} {
    gap: 40px;
    width: 564px;
    margin: 139px 0px 100px 0px;
  }

  ${media.tablet} {
    gap: 2.93vw;
    width: 45.02vw;
    margin: 4.59vw 0vw;
  }

  ${media.mobile} {
    gap: 7.009vw;
    width: 87.85vw;
    margin: unset;
  }
`
const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row-reverse;
  background: ${props =>
    props.$bgColor ? `${colors[props.$bgColor]}` : "unset"};
  gap: 6.528vw;
  width: 100%;

  ${media.fullWidth} {
    gap: 94px;
  }

  ${media.tablet} {
    gap: 9.18vw;
  }

  ${media.mobile} {
    flex-direction: column;
    gap: 10.667vw;
    padding: 9.346vw 7.593vw 0vw 7.593vw;
  }
`
